import axios from 'axios'
import * as utils from './api-utils'

export default {
  getVenue(venueCode) {
    return axios.get(utils.getApiUrl(`/venues/${venueCode}`))
  },
}
